import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import CoursesItem from "../../Components/CoursesItem/CoursesItem.";
import ProductCategoryHeader from "../../Components/ProductCategoryHeader/ProductCategoryHeader";
import ProductCategorySideBar from "../../Components/RecentArticles/RecentArticles";
import "./CourseCategory.css";
import { shuffle } from "lodash";
import { axiosConfig } from "../../Configuration/axios/axiosConfiguration";
import PaginationComponent from "../../Components/PaginationComponent/PaginationComponent";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function ProductCategory() {
    const colors = [
        "#7443FF",
        "#69B721",
        "#5F0101",
        "#7345FB",
        "#83CD1A",
        "#34ebe1",
        "#c034eb",
    ];
    const shuffledColors = shuffle(colors);
    const [searchParam, setSearchParam] = useSearchParams()
    const [courseList, setCourseList] = useState([]);
    const [courseCount, setCourseCount] = useState(0);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [orderType, setOrderType] = useState("RegisterDate");
    let itemsPerPage = 25;

    useEffect(() => {
        setPage(1);
    }, []);

    useEffect(() => {
        getData();
    }, [page, orderType, searchText]);

    const getData = () => {
        axiosConfig
            .get(
                `api/courses?page=${page}&pageSize=${itemsPerPage}&price=${searchParam.get("f") ?? "-1"}&orderBy=${orderType}` +
                (searchText !== undefined && searchText !== ""
                    ? `&searchText=${searchText}`
                    : "")
            )
            .then((res) => {
                setCourseList(res.data.data);
                setCourseCount(res.data.count);
            });
    };

    return (
        <>
            <Helmet>
                <title>دوره‌های آموزشی رایگان مدیریت و تولید | سه‌نیک</title>
                <meta
                    name="description"
                    content="دوره‌های آموزشی رایگان و تخصصی در حوزه مدیریت تولید، صنایع خانگی و بزرگ، با تدریس بر پایه ده‌ها سال تجربه دکتر منوچهر مزداپور. به خانواده علمی سه‌نیک بپیوندید و بدون محدودیت یاد بگیرید."
                />
            </Helmet>
            <div className="course-category">
                <Container>
                    <Row>
                        <Col lg={9}>
                            <ProductCategoryHeader
                                orderByChangeHandler={setOrderType}
                                searchChangeHandler={setSearchText}
                            />
                            <div className="course-category-content">
                                <Row>
                                    {courseList?.map((item, index) => (
                                        <Col md={6} lg={4}>
                                            <div className="course-category-course-item">
                                                <CoursesItem
                                                    backgroundColor={
                                                        shuffledColors[index]
                                                    }
                                                    item={item}
                                                />
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>
                            <div className="d-flex justify-content-center mt-5 ltr">
                                <PaginationComponent
                                    itemsCount={courseCount}
                                    itemsPerPage={24}
                                    currentPage={page}
                                    setCurrentPage={setPage}
                                    alwaysShown={true}
                                />
                            </div>
                        </Col>
                        <Col lg={3}>
                            <div className="course-category-sidebar">
                                <ProductCategorySideBar />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
